import { InputType } from '@/types';
import type { IInput } from '@/types';
import isBlobUrl from '@/utils/file/isBlobUrl';

/**
 * The Generate button gate: every input must be populated with usable data
 * — non-empty text or a CDN-hosted (non-blob) media URL that's finished
 * uploading.
 */
const isFormValid = (inputs: IInput[]): boolean =>
  inputs.every((input) => {
    if (input.type === InputType.TEXT) {
      return (input.value ?? '').trim().length > 0;
    }
    return Boolean(input.src) && !isBlobUrl(input.src) && !input.isLoading;
  });

export default isFormValid;
